/* eslint-disable no-underscore-dangle */
import helpers from '@/helpers/service';
import AxiosBase from '@/services/AxiosBase';

const isQA = process.env.VUE_APP_QA;
const apiBaseURL = isQA ? '/api-qa' : '/api';

class BaseService {
  constructor() {
    this.helpers = helpers;
  }

  _refreshInstance() {
    this.axios = new AxiosBase(apiBaseURL, true);
    this.axios.interceptors.response.use(null, this.helpers._errorHandler);
  }

  get(url = '', params) {
    this._refreshInstance();
    return this.axios.get(url, { params })
      .then(this.helpers._dataOnly)
      .catch(this.helpers._catch(null, true));
  }

  post(url = '', params) {
    this._refreshInstance();
    return this.axios.post(url, params)
      .then(this.helpers._dataOnly)
      .catch(this.helpers._catch(null, true));
  }

  delete(url = '') {
    this._refreshInstance();
    return this.axios.delete(url)
      .then(this.helpers._statusOnly)
      .catch(this.helpers._catch(null, true));
  }
}

export default BaseService;
